import CanAccessLink from "../../../shared/can-access-link";
import FilmanizeCheckbox from "../../../shared/filmanize-checkbox";

const AvailabilityActorsTable = (props) => {
  const {
    filmId,
    sectionLink,
    canAccess,
    people,
    potentialDates,
    linkGenerator,
    isLocation,
    editMode,
    personType,
    onAvailabilityChange
  } = props;

  const convertFromLocal = (localDates) => {
    return localDates.map((date) => {
      const localDate = new Date(date).toUTCString(); // Parse the local date
      return new Date(localDate).toDateString();
    });
  };

  const convertFromUtc = (localDates) => {
    return localDates.map((date) => {
      return new Date(date).toDateString();
    });
  };



  const handleNameClick = (actor, availableDates) => {
    if (!editMode || !onAvailabilityChange) return;

    // Check if all dates are available
    const allAvailable = potentialDates.every((potentialDate) =>
      availableDates.some((availableDate) => availableDate === potentialDate.date)
    );

    // Toggle all dates: if all available, deselect all; otherwise, select all
    potentialDates.forEach((potentialDate) => {
      onAvailabilityChange(personType, actor.id, potentialDate.date, !allAvailable);
    });
  };

  return (
    <>
      {(people || []).map((actor, index) => {
        const availableDates = isLocation ? convertFromLocal(actor.availableDates) : convertFromUtc(actor.availableDates);
        const link = linkGenerator ? linkGenerator(actor) : `/films/${filmId}/${sectionLink}/${actor.id}/edit`;

        return (
          <tr key={index}>
            <td className="day-out-days-table-actor-column">
              {editMode ? (
                <span
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={() => handleNameClick(actor, availableDates)}
                >
                  {actor.name}
                </span>
              ) : (
                <CanAccessLink to={link} canAccess={canAccess}>
                  {actor.name}
                </CanAccessLink>
              )}
            </td>
            <td>{actor.hasSubmitted && <i className="material-icons">check</i>}</td>
            {(potentialDates || []).map((potentialDate, dayIndex: number) => {
              const isAvailable = (availableDates || []).some((availableDate) => availableDate == potentialDate.date);

              return (
                <td className="has-text-centered" key={dayIndex}>
                  {editMode ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <FilmanizeCheckbox
                        checked={isAvailable}
                        onChange={(checked) => onAvailabilityChange(personType, actor.id, potentialDate.date, checked)}
                        label=""
                      />
                    </div>
                  ) : (
                    isAvailable && <span className="tag available-tag">Available</span>
                  )}
                </td>
              );
            })}
          </tr>
        );
      })}
    </>
  );
}


export default AvailabilityActorsTable;
